import { FormControl as _FormControl, Paper as _Paper, styled, Typography } from '@mui/material'
import { CSVLink } from 'react-csv'

export const Paper = styled(_Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
}))

export const VisuallyHidden = styled('span')(() => ({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  top: 20,
  width: 1,
}))

export const FormControl = styled(_FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 120,
}))

export const UserTypeLabel = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  color: theme.palette.primary.dark,
})) as typeof Typography

export const MySelfLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 11,
  color: theme.palette.error.dark,
})) as typeof Typography

export const IdText = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  color: theme.palette.grey[500],
})) as typeof Typography

export const CSVButton = styled(CSVLink)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
}))
